import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "vu_cookie_consent_v1";

export function getCookieConsent() {
    if (typeof window === "undefined") return null;
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); } catch { return null; }
}

export default function CookieConsent() {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const existing = getCookieConsent();
        if (!existing) setVisible(true);
        const onOpen = () => setVisible(true);
        window.addEventListener("vu:open-cookie-consent", onOpen);
        return () => window.removeEventListener("vu:open-cookie-consent", onOpen);
    }, []);

    const save = (choices) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            ...choices,
            accepted_at: new Date().toISOString(),
            version: 1,
        }));
        setVisible(false);
        window.dispatchEvent(new CustomEvent("vu:cookie-consent", { detail: choices }));
    };

    if (!visible) return null;

    return (
        <div
            className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] card-warm shadow-2xl p-5 fade-up"
            data-testid="cookie-consent"
            role="dialog"
            aria-live="polite"
            aria-label={t("cookies.title")}
        >
            <div className="font-serif text-lg">{t("cookies.title")}</div>
            <div className="text-sm text-[var(--text-ink)]/70 mt-1 leading-relaxed">
                {t("cookies.body")}{" "}
                <Link to="/privacy" className="underline text-[var(--brand-purple)] hover:text-[var(--brand-magenta)]" data-testid="cookie-privacy-link">{t("cookies.readPrivacy")}</Link>.
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
                <button
                    onClick={() => save({ essential: true, analytics: true })}
                    className="btn-primary text-sm"
                    data-testid="cookie-accept-all"
                >
                    {t("cookies.acceptAll")}
                </button>
                <button
                    onClick={() => save({ essential: true, analytics: false })}
                    className="btn-ghost text-sm"
                    data-testid="cookie-reject"
                >
                    {t("cookies.rejectNonEssential")}
                </button>
            </div>
        </div>
    );
}
